import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/patients/<anything>` — a stale address from when the record's id rode
 * the URL. The URL carries no patient id (Rachel, 08-10-2026 —
 * `DECISIONS.md`): the open record is memory state on the shell, so any
 * deeper path is a leftover bookmark or a typed guess, and it lands on the
 * index rather than a not-found page.
 */
export const Route = createFileRoute("/_authenticated/patients/$")({
  beforeLoad: () => {
    throw redirect({ to: "/patients" });
  },
});
